var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMsgHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMsgHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifications-SubMenu",
    transform: "translate(-1270.000000, -28.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Header",
    transform: "translate(0.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-top-header",
    transform: "translate(1184.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(66.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/primary-green",
    transform: "translate(0.652027, 0.979730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0533315,113.006757 C24.9936024,113.006757 24.9331647,112.992084 24.8786998,112.96284 C24.7592416,112.899127 24.6848333,112.774814 24.6848333,112.640854 L24.6848333,107.428179 C21.4584492,105.762776 19.6858108,102.846914 19.6858108,99.1935185 C19.6858108,93.5476091 24.9140311,89.2905405 31.847973,89.2905405 C38.7819148,89.2905405 44.0101351,93.5476091 44.0101351,99.1935185 C44.0101351,104.838624 38.7819148,109.095693 31.847973,109.095693 C31.6201925,109.095693 31.3968664,109.083332 31.1728316,109.071574 L31.1580511,109.07087 L25.2560056,112.945957 C25.1948591,112.986256 25.1240953,113.006757 25.0533315,113.006757 Z M26.222973,101.148649 C27.0625951,101.148649 27.7432432,100.468 27.7432432,99.6283784 C27.7432432,98.7887563 27.0625951,98.1081081 26.222973,98.1081081 C25.3833509,98.1081081 24.7027027,98.7887563 24.7027027,99.6283784 C24.7027027,100.468 25.3833509,101.148649 26.222973,101.148649 Z M31.847973,101.148649 C32.6875951,101.148649 33.3682432,100.468 33.3682432,99.6283784 C33.3682432,98.7887563 32.6875951,98.1081081 31.847973,98.1081081 C31.0083509,98.1081081 30.3277027,98.7887563 30.3277027,99.6283784 C30.3277027,100.468 31.0083509,101.148649 31.847973,101.148649 Z M37.472973,101.148649 C38.3125951,101.148649 38.9932432,100.468 38.9932432,99.6283784 C38.9932432,98.7887563 38.3125951,98.1081081 37.472973,98.1081081 C36.6333509,98.1081081 35.9527027,98.7887563 35.9527027,99.6283784 C35.9527027,100.468 36.6333509,101.148649 37.472973,101.148649 Z",
    id: "icMsgHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsgHeader);
export default __webpack_public_path__ + "static/media/icMsgHeader.152875b400e2123525b4306ff45a64d8.svg";
export { ForwardRef as ReactComponent };